import { PreCheckinField } from './precheckin-field.model';
import { EApplicationType } from '../enums/application-type.enum';

export interface IPreCheckinFormCustomization {
  trainingCenterId: string;
  applicationType: EApplicationType;
  checkinFields: PreCheckinField[]
}

export class PreCheckinFormCustomization implements IPreCheckinFormCustomization {
  trainingCenterId: string;
  applicationType: EApplicationType;
  checkinFields: PreCheckinField[]

  constructor(clone: PreCheckinFormCustomization = null) {
    this.trainingCenterId = '';
    this.applicationType = EApplicationType.Precheckin;
    this.checkinFields = [];

    if(clone){
      this.trainingCenterId = clone.trainingCenterId;
      this.applicationType = clone.applicationType;
      this.checkinFields = clone.checkinFields;
    }
  }
}

